<div #mapContainer class="map" aria-label="نقشه موقعیت خودروها"></div>
